import { gsap } from 'gsap'

export class Opening {
  constructor() {
    const loading = document.getElementById('js-loading')
    if (loading === null) return

    const kv = document.getElementById('js-index-kv')
    const body = document.querySelector('body')
    const loadingCopy = document.getElementById('js-loading-copy')
    const header = document.getElementById('js-header')

    const animation = () => {
      const tl1 = gsap.timeline()

      tl1.to(loading, {
        opacity: 1,
        onComplete: () => {
          loading.classList.add('is-start')
        },
      })
      tl1.fromTo(
        loadingCopy,
        {
          opacity: 0,
          onComplete: () => {
            loadingCopy.classList.add('is-start')
          },
        },
        {
          opacity: 1,
        },
        '+=2',
      )
      tl1.to(
        loadingCopy,
        {
          opacity: 0,
          onComplete: () => {
            kv.classList.add('kv-start')
          },
        },
        '+=1.6',
      )
      tl1.fromTo(
        header,
        {
          opacity: 0,
          y: -20,
        },
        {
          opacity: 1,
          y: 0,
          onComplete: () => {
            loading.classList.add('is-disabled')
            body.style.overflow = 'auto'
          },
        },
      )
    }
    const animationSecond = () => {
      const tl2 = gsap.timeline()
      tl2.to(kv, {
        onComplete: () => {
          body.style.overflow = 'auto'
          kv.classList.add('kv-start')
        },
      })
      tl2.fromTo(
        header,
        {
          opacity: 0,
          y: -20,
        },
        {
          opacity: 1,
          y: 0,
        },
      )
    }

    if (sessionStorage.getItem('loading') === null || sessionStorage.getItem('loading') != 'done') {
      animation()
      sessionStorage.setItem('loading', 'done')
    } else {
      loading.remove()
      body.style.overflow = 'auto'
      animationSecond()
    }
  }
}
